import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';
import Navbar from '../../components/Navbar/Navbar';
import icon from '../../assets/sidebar/uploadWhite.svg';
import isUserHaveRole from '../../utils/isUserHaveRole';
import { ROLE_ADMIN } from '../../constants/roles';

export const VIN_BLACKLIST_TABS = [
  { text: 'Ð¡Ð¿Ð¸ÑÐ¾Ðº VIN', navigate: '/vin-blacklist' },
  { text: 'ÐÐ°ÑÐ¸Ð½Ñ Ð² Ð±Ð°Ð·Ðµ', navigate: '/vin-blacklist/cars' },
];

// Ð§ÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº VIN: Ð´Ð²Ðµ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸, ÐºÐ°Ðº Ñ Â«Ð¡Ð´ÐµÐ»Ð¾ÐºÂ» Ð¸ Â«ÐÐ»Ð¸ÐµÐ½ÑÐ¾Ð²Â». Ð¢Ð¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾Ñ: Ð±ÑÐº ÑÐ¾Ð¶Ðµ Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ
// ÑÐ¾Ð»Ñ, Ð·Ð´ÐµÑÑ â ÑÑÐ¾Ð±Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐ¼ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ñ Ð¾ÑÐ¸Ð±ÐºÐ°Ð¼Ð¸.
const VinBlacklistNavigation = () => {
  const { pathname } = useLocation();

  if (!isUserHaveRole(ROLE_ADMIN)) {
    return <Navigate to="/" replace />;
  }

  const current = VIN_BLACKLIST_TABS.find((tab) => tab.navigate === pathname) || VIN_BLACKLIST_TABS[0];

  return (
    <>
      <Header title="Ð§ÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº VIN" icon={icon} />
      <Breadcrumbs navigate="/vin-blacklist" link="Ð§ÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº VIN" currentPage={current.text} />
      <Navbar items={VIN_BLACKLIST_TABS} />
      <Outlet />
    </>
  );
};

export default VinBlacklistNavigation;
